module.exports = __webpack_public_path__ + "static/media/mouse-pointer.7221cb86.svg";